/* eslint-disable import/no-anonymous-default-export */
export default {
  API_BASE_ENDPOINT: process.env.REACT_APP_API_BASE_ENDPOINT,
  SESSION_IDLE_TIMEOUT_MS: 15 * 60 * 1000,
  USER_TYPE: {
    ADMINISTRATOR: "Administrator",
  },
  TOAST_TYPE: {
    SUCCESS: "success",
    ERROR: "error",
  },
  ITEM_TYPE: ["Shirt", "Pant", "Shoe"],
  GENDER: ["Male", "Female"],
};
